<style lang="scss">
    @import "../components/self-cropper/index";
</style>
<template>
    <el-dialog  @click.native.stop
                width="1000px"
               class="global-dialog cropper-app cropper-tpl-group"
                title="素材裁剪"
               :visible.sync="dialogVisible"
               :append-to-body="true"
               :close-on-click-modal="false">
        <section class="m-cropper"
                 v-loading="imgLoading"
                 element-loading-text="加载图片中..."
                 element-loading-spinner="el-icon-loading">
            <div class="preview-box">
                <div class="img-content">
                    <slot name="view" v-if="previewVisible" :psdJson="psdDataClone.json" :scale="previewScale" ></slot>
                </div>
            </div>
            <div class="cc-overflow" ref="imgBoxRef">
                <div class="cropper-container" :style="{width: '580px', height: '400px'}">
                    <VueCropper :class="{'circle-img': borderRadius}"
                                ref="cropper"
                                :img="imgItem.originUrl"
                                :outputSize="option.size"
                                :outputType="option.outputType"
                                :auto-crop-width="imgItem.width"
                                :auto-crop-height="imgItem.height"
                                :fixedNumber="[imgItem.width, imgItem.height]"
                                :autoCrop="true"
                                :high="true"
                                :canMove="false"
                                :canScale="true"
                                :infoTrue="true"
                                :fixed="fixed"
                                :full="true"
                                @initScaleChange="initScaleChange"
                                @imgLoadSuccess="onImgLoad"
                                @crop-update="onCrop">上传素材
                    </VueCropper>
                </div>
                <div class="cropper-scale-tools">
                    <i class="el-icon-zoom-out" @click="onMinus" title="缩小"></i>
                    <i class="el-icon-zoom-in" @click="onPlus" title="放大"></i>
                </div>
            </div>
        </section>
        <footer slot="footer">
            <el-button type="default" @click="onCancel">取消</el-button>
            <el-button type="primary" @click="complete" :loading="loading">完成编辑</el-button>
        </footer>
    </el-dialog>
</template>
<script>
    import VueCropper from '../components/self-cropper/vue-cropper';
    import util from '@/util.js'
    export default {
        components: {
            VueCropper
        },
        props: {
            value: Boolean,
            psdData: {
                type: Object,
                default: () => {
                    return {json: []};
                }
            },
            selectedItem: Object,
            fixed:{
                type: Boolean, default: true
            },
            keyMap:{
                type: Object, default(){
                    return {
                        key: 'id', oldKey: 'oldId'
                    }
                }
            }
        },
        data() {
            return {
                previewUrl: '',
                option: {
                    size: 1,
                    outputType: 'png',
                },
                imgLoading: true,
                psdDataClone: {json: {}},
                psdImgItem: {},
                imgItem: {
                    originUrl: '',
                    url: '',
                    width: 0,
                    height: 0
                },
                cropScale: 1,
                bodyWidth: 0,
                bodyHeight: 0,
                previewScale: 1,
                loading: false,
                autoWidth: 0,
                autoHeight: 0,
                previewVisible: false,
                borderRadius: null,
            }
        },
        computed: {
            dialogVisible: {
                get() {
                    return this.$store.state.templateGroup.cropperDialogVisible;
                },
                set(v) {
                    this.$store.commit('templateGroup/toggle_cropper_dialog', v);
                }
            },
            imgBoxStyle() {
                let item = this.imgItem;
                let scale = this.getBoxScale();
                return `height: ${+item.height + 100}px; zoom: ${scale}`;
            }
        },
        watch: {
            dialogVisible(v) {
                if (v) {
                    this.init();
                }
            }
        },
        methods: {
            init() {
                window.cr = this;
                this.psdDataClone = JSON.parse(JSON.stringify(this.psdData));
                this.setScale();
                let selectedItem = this.selectedItem;
                this.setImgItem(this.psdDataClone, selectedItem);
                let item = this.imgItem;
                if (!item.originUrl || item[this.keyMap.oldKey] !== selectedItem[this.keyMap.key]) {
                    this.imgLoading = true;
                    item[this.keyMap.oldKey] = selectedItem[this.keyMap.key];
                    item.originUrl = selectedItem.url;
                }
                Object.assign(item, selectedItem);
                this.previewVisible = true;
                this.borderRadius = selectedItem.borderRadius;
            },
            getItemById(children, oldId, callback) {
                if (this.stop) {
                    return;
                }
                children.forEach((item) => {
                    if (item.children) {
                        this.getItemById(item.children, oldId, callback)
                    } else if (oldId === item[this.keyMap.key]) {
                        this.stop = true;
                        callback(item);
                    }
                });
            },
            setImgItem(psdData, selectedItem) {
                let data = psdData.json;
                let children = data.children;
                this.getItemById(children, selectedItem[this.keyMap.key], (imgItem) => {
                    this.psdImgItem = imgItem;
                    this.stop = false;
                });
            },
            getBoxScale() {
                let width = window.innerWidth - 340, height = window.innerHeight - 170;
                let item = this.imgItem;
                let imgWidth = +item.width, imgHeight = +item.height;
                let scaleW = 1, scaleH = 1, scale = 1;
                if (imgWidth > width) {
                    scaleW = parseFloat((width / imgWidth).toFixed(2));
                }
                if (imgHeight > height) {
                    scaleH = parseFloat((height / imgHeight).toFixed(2));
                }
                scale = scaleW > scaleH ? scaleH : scaleW;
                return scale;
            },
            _clearOriginUrl() {
                this.imgItem.originUrl = '';
            },
            setScale() {
                let w = +this.psdDataClone.json.width;
                this.previewScale = parseFloat((280 / w).toFixed(2));
            },
            onImgLoad(img) {
                this.imgWidth = img.width;
                this.imgHeight = img.height;
                this.imgLoading = false;
                this.$nextTick(() => {
                    this.initView = true; // 初始打开页面时，避免模板内的图片自动更新
                });
            },
            initScaleChange(baseScale, w, h){
                if(w === this.imgWidth){
                    return;
                }
                if(w < this.imgWidth){ // 图片超出截图容器时，容器自动缩放比例与图片显示比例不一致，引处再校对一次
                    let scale = w / this.imgWidth * baseScale;
                    this.$refs.cropper.setInitScale(scale)
                }else{
                    let cropScale = this.imgWidth / w;
                    let scale = cropScale * baseScale;
                    this.$refs.cropper.setInitCropAndScale(scale, this.imgWidth * scale, this.imgHeight * scale)
                }
            },
            download() {
                let aLink = document.createElement('a');
                aLink.download = 'demo';
                this.$refs.cropper.getCropData((data) => {
                    aLink.href = data;
                    aLink.click();
                });
            },
            onCrop() {
                if(this.initView === undefined){
                    return;
                }
                if(this.initView){
                    this.initView = false; // 初始打开页面时，避免模板内的图片自动更新, 只有操作后 才更新截图到模板内
                    return;
                }
                if (this.timeoutVal) {
                    clearTimeout(this.timeoutVal);
                    this.timeoutVal = null;
                }
                this.timeoutVal = setTimeout(() => {
                    this.timeoutVal = null;
                    this.$refs.cropper.getCropData((data) => {
                        this.psdImgItem.url = data;
                        this.psdImgItem.key = util.getUUID();
                        this.psdImgItem.coverObj = null;
                    })
                }, 300);
            },
            changeScale(num) {
                num = num || 1;
                this.$refs.cropper.changeScale(num);
            },
            refreshCrop() {
                this.$refs.cropper.refresh();
            },
            complete() {
                this.loading = true;
                this.$refs.cropper.getCropData((data) => {
                    this.$emit('completed', data);
                    this.selectedItem.coverObj = null;
                    this.$nextTick(() => {
                        this.loading = false;
                        this.dialogVisible = false;
                    })
                });
            },
            onCancel() {
                this.dialogVisible = false;
            },
            onPlus() {
                this.$refs.cropper.changeScale(1);
                this.onCrop();
            },
            onMinus() {
                this.$refs.cropper.changeScale(-1);
                this.onCrop();
            }
        }
    }
</script>


